import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7dd4cf17"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "forecasting-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "forecasting-text"
}, " Estimate the future demand per product leveraging recent sales velocity adjusted by a seasonal or a manual boost. ", -1));
const _hoisted_3 = {
  class: "forecasting-box"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "forecasting-title"
}, "VELOCITY CALCULATION TYPE", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "forecasting-description"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "forecasting-description-title"
}, "Weighted velocity"), /*#__PURE__*/_createElementVNode("div", {
  class: "forecasting-description-text"
}, " Drag to adjust the weight of each period to estimate the average product velocity ")], -1));
const _hoisted_6 = {
  class: "forecasting-velocity",
  ref: "velocity"
};
const _hoisted_7 = {
  class: "forecasting-velocity-percents"
};
const _hoisted_8 = ["onMousedown"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "forecasting-line"
}, null, -1));
const _hoisted_10 = {
  class: "forecasting-box"
};
const _hoisted_11 = {
  class: "forecasting-title-box"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "forecasting-title"
}, "ADDITIONAL BOOST", -1));
const _hoisted_13 = {
  class: "forecasting-slider"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_demand_forecasting_settings_grid = _resolveComponent("demand-forecasting-settings-grid");
  const _component_app_switch = _resolveComponent("app-switch");
  const _component_app_select = _resolveComponent("app-select");
  const _component_app_slider = _resolveComponent("app-slider");
  const _component_demand_forecasting_settings_seasonal = _resolveComponent("demand-forecasting-settings-seasonal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", {
    class: "forecasting-velocity-box",
    onMouseup: _cache[0] || (_cache[0] = (...args) => $options.onResizeStop && $options.onResizeStop(...args)),
    onMousemove: _cache[1] || (_cache[1] = (...args) => $options.onResize && $options.onResize(...args))
  }, [_createVNode(_component_demand_forecasting_settings_grid, {
    width: 528,
    height: 444,
    "x-data": $data.data.x,
    "y-data": $data.data.y
  }, null, 8, ["x-data", "y-data"]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($options.currentSettings.forecasting_velocity), key => {
    return _openBlock(), _createElementBlock("div", {
      key: key,
      class: "forecasting-velocity-item"
    }, [_createElementVNode("div", {
      ref_for: true,
      ref: `bar-${key}`,
      class: _normalizeClass(['forecasting-velocity-bar', {
        resize: $data.resizeBar == key
      }]),
      style: _normalizeStyle(`height: ${$options.calculateHeight($options.currentSettings.forecasting_velocity[key], key)}px`)
    }, [_createElementVNode("div", _hoisted_7, _toDisplayString($options.calculatePercent(key).toFixed()) + "% ", 1), _createElementVNode("div", {
      class: "forecasting-velocity-resizer",
      onMousedown: $event => $options.onResizeStart($event, key)
    }, null, 40, _hoisted_8)], 6)]);
  }), 128))], 512)], 32)]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_app_switch, {
    modelValue: $options.currentSettings.boost_active,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $options.currentSettings.boost_active = $event),
    onChange: $options.onUpdate
  }, null, 8, ["modelValue", "onChange"])]), _createElementVNode("div", {
    class: _normalizeClass(['forecasting-boosts-content', {
      disabled: !$options.currentSettings.boost_active
    }])
  }, [_createVNode(_component_app_select, {
    modelValue: $options.currentSettings.boost_type,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.currentSettings.boost_type = $event),
    options: $data.boost_types,
    v2: "",
    label: "Boosts type",
    onChange: $options.onUpdate
  }, null, 8, ["modelValue", "options", "onChange"]), _createElementVNode("div", _hoisted_13, [$options.currentSettings.boost_type == 'manual' ? (_openBlock(), _createBlock(_component_app_slider, {
    key: 0,
    modelValue: $options.currentSettings.manual_boost_value.value,
    "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => $options.currentSettings.manual_boost_value.value = $event), $options.onUpdateManualBoostValue],
    options: $data.percents,
    "padding-top": 0,
    "padding-bottom": 12,
    variant: "custom",
    labelWidth: 6,
    mixed: "",
    onChange: $options.onUpdateManualBoostValue
  }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true), $options.currentSettings.boost_type == 'seasonal' ? (_openBlock(), _createBlock(_component_demand_forecasting_settings_seasonal, {
    key: 1,
    modelValue: $options.currentSettings.seasonal_boost_value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $options.currentSettings.seasonal_boost_value = $event),
    percents: $data.percents,
    onChange: $options.onUpdateSeasonalBoostValue
  }, null, 8, ["modelValue", "percents", "onChange"])) : _createCommentVNode("", true)])], 2)])]);
}